import React from 'react';
import clsx from 'clsx';
import ReactTooltip from 'react-tooltip';

const  ratingToColor = (score) => {
    const rating = score * 100;
    let color = "Gray";
	if (rating < 20) color = "Tomato";
	else if (rating < 40) color = "Orange";
	else if (rating < 60) color = "Gold";
	else if (rating < 80) color = "YellowGreen ";
	else if (rating <= 100) color = "ForestGreen";
	return color;
}

const TitleCard = ({title,tooltipMessage}) => 
    (
        <div style={{
            display: 'flex', 
            borderTopLeftRadius: '0.5rem', 
            borderTopRightRadius: '0.5rem',
            border: 'solid', 
            borderColor: '#0c4d82',
            flexDirection: 'row', 
            justifyContent: 'space-between', 
            backgroundColor: '#0c4d82', 
            color: 'white', 
            padding: '0.5rem',
            boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
        }}
        >
            <div> {title}</div>
            <svg data-tip={tooltipMessage} data-html="true"  className={clsx('teamSelector')} style={{fill: 'white',width: '1.5rem'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="InfoIcon"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
            <ReactTooltip place='left' effect='solid' />
        </div>
    )

const ReadabilityLabel = () => 
    (
        <span data-tip='Readability' style={{borderRadius: '50%', marginLeft: '0.7rem',backgroundColor: 'rgb(189, 189, 189)'}}>
            <div style={{minWidth: '1.5rem',display: 'flex', alignItems: 'center', justifyContent: 'center',padding: '0.4rem'}}>
                <svg style={{fill: 'white',width: '1rem'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="MenuBookIcon"><path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/><path d="M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zm4.5 1.84c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z"/></svg>    
            </div>
        </span>
    )

const ValueSection = ({value, score}) => 
    (
        <div style={{display: 'flex', justifyContent: 'center', marginTop: '1rem'}}>
            <span style={{border: 'solid', borderRadius: '0.5rem', color: 'white', fontSize: '1.125rem', lineHeight: '1.6', backgroundColor: ratingToColor(score), paddingTop: '0.7rem', paddingBottom: '0.7rem', paddingRight: '1.7rem', paddingLeft: '1.7rem', minWidth: '30%', display: 'flex', justifyContent: 'center'}}> {value}</span>
        </div>
    )

const MaintainabilityLabel = () => 
    (
        <span data-tip='Maintainability' style={{borderRadius: '50%',marginLeft: '0.7rem', backgroundColor: 'rgb(189, 189, 189)'}}>
            <div style={{minWidth: '1.5rem',display: 'flex', alignItems: 'center', justifyContent: 'center',padding: '0.4rem'}}>
                <svg style={{fill: 'white',width: '1rem'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="BuildIcon"><path d="m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/></svg>
            </div>    
        </span>
    )

const ReusabilityLabel = () => 
    (
        <span data-tip='Reusability' style={{borderRadius: '50%',marginLeft: '0.7rem', backgroundColor: 'rgb(189, 189, 189)'}}>
            <div style={{minWidth: '1.5rem',display: 'flex', alignItems: 'center', justifyContent: 'center',padding: '0.4rem'}}>
                <svg style={{fill: 'white',width: '1rem'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="CachedIcon"><path d="m19 8-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"/></svg>
            </div>    
        </span>
    )

const SecurityLabel = () => 
    (
        <span data-tip='Security' style={{borderRadius: '50%', marginLeft: '0.7rem',backgroundColor: 'rgb(189, 189, 189)'}}>
            <div style={{minWidth: '1.5rem',display: 'flex', alignItems: 'center', justifyContent: 'center',padding: '0.4rem'}}>
                <svg style={{fill: 'white',width: '1rem'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="SecurityIcon"><path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/></svg>            
            </div>
        </span>
    )

export {
    TitleCard,
    ValueSection,
    MaintainabilityLabel,
    ReusabilityLabel,
    ReadabilityLabel,
    SecurityLabel
}